/**
 * 项目管理
 */
const ProjectRouter = {
  path: '/monthly',
  component: () => import('@/views/layout'),
  redirect: '/monthly/report/list',
  alwaysShow: true,
  meta: {
    title: '统计分析',
    icon: require('@/assets/slider/report.png')
  },
  children: [
    {
      path: 'report/list',
      name: 'monthly_report',
      component: () => import('@/views/monthly_report/staff'),
      meta: {
        title: '人员分析'
      }
    },
    {
      path: 'project/list',
      name: 'monthly_project',
      component: () => import('@/views/monthly_report/project'),
      meta: {
        title: '项目分析'
      }
    },

    {
      path: 'form/list',
      name: 'everyday',
      component: () => import('@/views/monthly_report/everay/index'),
      meta: {
        title: '报表',
        keepAlive:true
      },
      // alwaysShow: true,
      // children: [
      //   {
      //     path: 'list',
      //     name: 'everyday_form',
      //     component: () => import('@/views/monthly_report/everay/everyday_form'),
      //     meta: {
      //       title: '班次统计'
      //     }
      //   },
      //   {
      //     path: 'materiel/list',
      //     name: 'materiel',
      //     component: () => import('@/views/monthly_report/materiel'),
      //     meta: {
      //       title: '后勤装备统计'
      //     }
      //   },

      //   // {
      //   //   path: 'abnormal/list',
      //   //   name: 'project_abnormal',
      //   //   component: () => import('@/views/monthly_report/project_abnormal'),
      //   //   meta: {
      //   //     title: '项目异常统计'
      //   //   }
      //   // },
      //   // {
      //   //   path: 'list2',
      //   //   name: 'everyday_black_white',
      //   //   component: () => import('@/views/monthly_report/everay/everyday_black_white'),
      //   //   meta: {
      //   //     title: '黑白班统计'
      //   //   }
      //   // },

      // ]
    },

  ]
}

export default ProjectRouter
